if (!customElements.get("product-bundle-info")) {
  class ProductBundleInfo extends HTMLElement {
    constructor() {
      super();
      this.bundleItems = this.querySelectorAll(".bundle-item");
      this.firstItems = this.querySelectorAll(".bundle-first");
      this.handleItemClick = this.handleItemClick.bind(this);
      this.handleItemKeydown = this.handleItemKeydown.bind(this);
    }

    connectedCallback() {
      this.initEventListeners();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    initEventListeners() {
      this.firstItems.forEach((item) => {
        item.addEventListener("click", this.handleItemClick);
        //keyboard
        item.addEventListener("keydown", this.handleItemKeydown);
      });
    }

    handleItemKeydown(e) {
        if (e.key === "Enter" || e.key === "NumpadEnter" || e.key === " ") {
          e.preventDefault();
          this.handleItemClick(e);
        }
    }

    removeEventListeners() {
      this.firstItems.forEach((item) => {
        item.removeEventListener("click", this.handleItemClick);
        item.removeEventListener("keydown", this.handleItemKeydown);
      });
    }
    getItemInfo(item) {
      const itemPriceEl = item.querySelector(".bundle-on-sale");
      const itemPrice = itemPriceEl ? Number(itemPriceEl.getAttribute("data-content")) : 0;
    
      const comparePriceEl = item.querySelector(".bundle-compare-at");
      const comparePrice = comparePriceEl ? Number(comparePriceEl.getAttribute("data-content")) : itemPrice;
    
      const id = item.getAttribute("data-id");
      const bundleType = item.getAttribute("data-bundle-type") || "";
      const bundleIds = (item.getAttribute("data-bundle-ids") || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);
    
      const rawColor =
        item.getAttribute("data-color") ||
        item.querySelector(".bundle-color")?.textContent?.trim() ||
        "";
    
      const color = bundleType === "bundle_discount" ? "" : rawColor === "Default Title" ? "" : (rawColor || "");
    
      return { itemPrice, comparePrice, id, color, bundleType, bundleIds };
    }
    
    handleItemClick(e) {
      const clickedItem = e.currentTarget;
      const bundleItem = clickedItem.closest(".bundle-item");
      if (!bundleItem) return;
      this.bundleItems.forEach((item,index) => {
        if (item === bundleItem) {
          if (item.classList.contains("active")) return;
          item.classList.add("active");
          if (index == 0) {
            clickedItem.closest(".product-template-container").classList.remove("hide-multi-attributes");
          } else {
            const container = clickedItem.closest(".product-template-container");
            container.classList.add("hide-multi-attributes");
            
            // Auto-reset accessory quantities to 0 when hiding the Frequently Bought Together section
            const minusButtons = container.querySelectorAll(".header-case-content .js-case__adjust[data-qty='-1']");
            minusButtons.forEach(btn => {
              const input = btn.closest(".case-item-container")?.querySelector(".js-case-qty__num");
              let maxLoops = 100;
              while (input && parseInt(input.value) > 0 && maxLoops > 0) {
                btn.click();
                maxLoops--;
              }
            });
          }
        } else {
          item.classList.remove("active");
        }
      });
      this.dispatchBundleInfoChange(this.getItemInfo(bundleItem));
    }
    dispatchBundleInfoChange({ itemPrice, comparePrice ,id,color,bundleType,bundleIds }) {
      this.dispatchEvent(
        new CustomEvent("bundle:InfoChange", {
          bubbles: true,
          cancelable: true,
          detail: {
            itemPrice: itemPrice,
            comparePrice: comparePrice,
            id: id,
            color: color,
            bundleType: bundleType,
            bundleIds: bundleIds,
          },
        })
      );
    }
  }
  customElements.define("product-bundle-info", ProductBundleInfo);
}
